import { createTheme } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { createContext, useContext, useEffect } from 'react';

import { lightTheme } from '../theme';

const ThemeContext = createContext(null);

// Dark mode is intentionally disabled: the app always renders the light theme,
// regardless of the OS/browser `prefers-color-scheme` setting or any previously
// saved `darkMode` preference. The context shape is preserved so existing
// consumers of useTheme() keep working.
const theme = createTheme(lightTheme);
const noop = () => {};

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.classList.remove('dark');
    }
    try {
      localStorage.removeItem('darkMode');
    } catch {
      // ignore storage errors
    }
  }, []);

  return (
    <ThemeContext.Provider value={{ isDarkMode: false, toggleTheme: noop }}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
